<template lang="html">
  <div class="">
    <AccountSubheader />
    <p>Integrations</p>
    <IntegrationsComponent />
  </div>
</template>

<script>
import AccountSubheader from '../../components/AccountComponents/AccountSubheader';
import IntegrationsComponent from '../../components/AccountComponents/IntegrationsComponent';
export default {
  name: "IntegrationsPage",
  components: {
    AccountSubheader,
    IntegrationsComponent
  }
}
</script>

<style lang="css" scoped>
div p{
  color: rgb(60, 3, 140);
  font-size: 36px;
  font-weight: bold;
}
</style>
